// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"mapStyles_wrapper__3WbWq","mapWrapper":"mapStyles_mapWrapper__t_Rnv","marker":"mapStyles_marker__3BEJB"};